import { Component, EventEmitter, ViewChild, Input, NgZone, Output, OnDestroy } from '@angular/core';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import * as Materialize from 'angular2-materialize/dist/index';
import { Observable } from 'rxjs/Rx';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { S3CredService } from '../shared/s3-cred-service';
import * as globals from '../globals';
import { DropzoneWorkspaceComponent } from '../dropzone/dropzone-workspace.component';
import { DropzoneAttachComponent } from '../dropzone/dropzone-attach.component';
import { DropzoneComponent } from '../dropzone/dropzone.component';
import { CreateProjectService } from './createproject.service';
import { UploadService } from '../shared/upload.service';
import { UtilsService } from '../shared/utils.service';
import { SharedService } from '../shared/shared.service';



declare var openNewBrowserWindow: any;


@Component({
    selector: 'create-project',
    templateUrl: './createproject.component.html',
    styleUrls: ['./createproject.component.css'],
    providers: [CreateProjectService]
  })
export class CreateProjectComponent implements OnDestroy {

  projectname: string = '';
  partnumber: string = '';
  revision: string = '';
  projectdescription: string;
  selectedmaterial: string;
  materialselect: number;
  selectedcustomer: string;
  customerselect: number;
  selectedowner: string;
  ownerselect: number;
  public elementRef;
  materialArray: any = [];
  materialDict: any = {};
  ownerArray: any = [];
  ownerDict: any = {};
  customerArray: any = [];
  customerDict: any = {};
  statusArray: any = ['OPEN', 'WIP', 'REVIEW', 'APPROVED', 'MADE'];
  modelToDelete: any = [];
  ModelToProject: any = [];
  email = '';
  uploadprojectTabOn = false;
  showUploadButton: boolean = false;
  dupnames = [];
  dupfilenames = [];
  dupnumbers = [];
  public checkDuplications: boolean = false;
  duplicateFilename: boolean = false;
  tenanturl: string = '';
  bucketname = globals.BUCKETNAME;
  tenantid: string = '';
  planid: string;
  @Input() _service: any;
  @Input() filter;
  @Input() config;
  uploadfilebtnstatus: boolean = true;
  createicon = '';
  public progresses: any = [];
  errorMessage: string;
  createanywayicon = '';
  createanyway2icon = '';
  createButtonStatus: boolean = false;
  duplicateName: boolean = false;
  duplicateNumber: boolean = false;
  confirmed: boolean = false;

  modelSelectedForProject: boolean = false;
  modelPresent: boolean = false;
  filesToUpload: Array<File>;
  uploadingproject: boolean = false;
  progressbarActive: boolean = false;
  uploadCurrentValue: number;
  projectfilename = '';
  recipeTemplate: any;

  // the variables below this comment were called in the HTML template but were causing the build to fail

  materialEdit: any;
  customerEdit: any;
  ownerEdit: any;
  recipeTemplateEdit: any;
  recipeTemplates: any;

  // the variables above this comment were called in the HTML template but were causing the build to fail


  private customerurl = globals.APIURL + '/customer';

      companyname: string;
      addressone: string;
      addresstwo: string;
      companycity: string;
      companystate: string;
      companyzip: string;
      companycountry: string;
      companyphone: string;
      companyfax: string;
      companyurl: string;
      primarycontactfirstname: string;
      primarycontactlastname: string;
      primarycontactemail: string;
      primarycontactphone: string;
      accountowner: string;
      requiredfieldEmpty: boolean = true;
      waiticon: string;
      CustrequiredfieldEmpty: boolean = false;


      @Output() AddCustomerCompleteAction = new EventEmitter();
      modalNewAccountAction = new EventEmitter<string | MaterializeAction>();

  modalModel2ProjectAction = new EventEmitter<string | MaterializeAction>();
  modalcreateProjectConfirmAction = new EventEmitter<string | MaterializeAction>();

  @ViewChild(DropzoneWorkspaceComponent) _dropzoneWorkspace: DropzoneWorkspaceComponent;
  @ViewChild(DropzoneAttachComponent) _dropzoneattach: DropzoneAttachComponent;
  @ViewChild(DropzoneComponent) _dropzone: DropzoneComponent;

  @Output() ProjectCompleteAction = new EventEmitter();


  constructor(public s3CredService: S3CredService, private createProjectService: CreateProjectService, private uploadService: UploadService,
    private ngZone: NgZone, private utilsService: UtilsService, private service: SharedService, public authHttp: AuthHttp) {
      this._service = service;
    }

    ngOnInit() {
      this.service.getCorporateInfo().subscribe(
        data => {
          let jdata = JSON.parse(data);
          this.recipeTemplates = jdata.templates;
          this.customerArray = jdata.customers;
          this.materialArray = jdata.materials;
          this.ownerArray = jdata.owners;

          if (this.materialArray) {
            for (let i = 0; i < this.materialArray.length; i++) {
              this.materialDict[this.materialArray[i].id] = this.materialArray[i].name;
            }
          }

          if (this.ownerArray) {
            for (let i = 0; i < this.ownerArray.length; i++) {
              this.ownerDict[this.ownerArray[i].id] = this.ownerArray[i].email;
              if (this.email === this.ownerArray[i].email) {
                this.ownerselect = this.ownerArray[i].id;
              }
            }
          }

          if (this.customerArray) {
            for (let i = 0; i < this.customerArray.length; i++) {
              this.customerDict[this.customerArray[i].id] = this.customerArray[i].name;
            }
          }

          // Could do something like this if we wanted to let them choose to not add a template after they start to select one (same for other fields too)
          // this.recipeTemplates.unshift({name: 'None', id: -1});
        },
        error => {

        }
      );
    }

    ngOnDestroy() {
      this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
      this.modalcreateProjectConfirmAction.emit({ action: 'modal', params: ['close'] });
    }

  openModalModel2Project(model: any, tenantid: string, tenanturl: string, bucketname: string, planid: string) {

    this.createicon = '';
    // Check for model (coming from Workspace)
    if ( model != '') {
      this.modelSelectedForProject = true;
      this.modelPresent = true;
      this.ModelToProject = [];
      this.ModelToProject = model;
      this.projectname = this.ModelToProject.filenamenoext;
      this.partnumber = this.ModelToProject.filenamenoext;
    } else {
      this.clearDropzone();
      this.modelSelectedForProject = false;
      this.modelPresent = false;
      this.ModelToProject = [];
      this.projectname = '';
      this.partnumber = '';
    }
    $('#projectname').val(this.projectname);
    $('#partnumber').val(this.partnumber);
    $('#projectname').change();
    $('#partnumber').change();
    this.selectedowner = this.email;
    $('#Owner').val(this.selectedowner);
    $('#Owner').change();
    this.uploadprojectTabOn = true;
    this.showUploadButton = false;
    this.modalModel2ProjectAction.emit({ action: 'modal', params: ['open'] });
    this.dupnames = [];
    this.dupfilenames = [];
    this.dupnumbers = [];
    this.checkDuplications = true;
    this.duplicateFilename = false;
    this.tenantid = tenantid;
    this.tenanturl = tenanturl;
    this.bucketname = bucketname;
    this.planid = planid;

    jQuery('ul.tabs').tabs();
    jQuery('ul.tabs').tabs('select_tab', 'projectDetails');
    jQuery('#projectDetailstab').addClass('active');
    this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
      jQuery(document).ready(function () {

        jQuery('#projectDetailstab').click();
        // jQuery('.modal').modal({
        //   ready: function (modal, trigger) { // Callback for Modal open. Modal and trigger parameters available.

        //     $('#modalModel2Project').find('.indicator').attr('style', 'right: 66%; left: 0%;');

        //   },
        //   complete: function() {
        //      alert('Closed');
        //      } // Callback for Modal close

        // });
      });
    });
    let duplicationParams = {
      filename: this.ModelToProject.filename
    };
    this.createProjectService.checkDuplications(duplicationParams)
    .subscribe(
      data => {
        jQuery('#projectDetailstab').click();
        console.log('Duplication data = ', data);
        let DupCheckData = JSON.parse(data);
        this.checkDuplications = false;
        this.dupfilenames = DupCheckData.dupfilenames;
        if (this.dupfilenames.length > 0) {
          this.duplicateFilename = true;
          for (let key in this.dupfilenames) {
            let filenamenoext = this.dupfilenames[key].filename.replace(/\.[^/.]+$/, '');    // Need to get file name from response
            if (!filenamenoext) {
              filenamenoext = ' ';
            }
            filenamenoext = filenamenoext.replace(/[+]/g, '%2B');
            this.dupfilenames[key].filenamenoext = filenamenoext;
            this.dupfilenames[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.dupfilenames[key].id + '/' + filenamenoext + '_320x240.png';
          }
        }

        let DupResult = [];

      },
      error => {
      }
    );
  }

  uploadAttachments(refreshAfterComplete) {
    console.log('File attachment : ', this._service.getFileArrayofAttchments());
    let filedataAttachments = this._service.getFileArrayofAttchments().slice();
    if (!this.ModelToProject) {
      return;
    }

    if (filedataAttachments.length) {
      // (<HTMLInputElement>document.getElementById('uploadAttachmentButton')).disabled = true;
      this.uploadfilebtnstatus = true;
    } else {
      this.createicon = '';
      Materialize.toast('NO FILE IS ATTACHED TO UPLOAD', 3000);
      return;
    }

    this.s3CredService.getProjectS3Creds(this.ModelToProject.id)
    .subscribe(
      data => {
        let s3credentials = JSON.parse(data);
        let policy = s3credentials.s3creds.s3Policy;
        let signature = s3credentials.s3creds.s3Signature;
        let serverdate = s3credentials.s3creds.serverDate;

        let attchmentUploadCount = 0;
        let progressCount = 0;
        for (let uploadfilecount = 0; uploadfilecount < filedataAttachments.length; uploadfilecount++) {
          let filepath = filedataAttachments[uploadfilecount].fullPath;
          console.log('File path : ', filepath);

          // check for files which has only extensions and names is mising
          let splitname = filedataAttachments[uploadfilecount].name.split('.');
          if (!splitname[0]) {
            continue;
          }
          if (!filedataAttachments[uploadfilecount].name.includes('.')) {
            continue;
          }
          this.progresses.push({ id: progressCount, currentValue: 1, name: filedataAttachments[uploadfilecount].name });

          // Upload the file to the newly created project bucket/folder
          this.uploadService.makeFileRequest(this.tenanturl, [filepath, uploadfilecount, progressCount], filedataAttachments, this.ModelToProject.id, '', this.tenantid, this.planid, policy, signature, serverdate).then((result) => {
            console.log('Uploaded file. Result:', result);
            attchmentUploadCount++;
            // if (filedataAttachments.length == attchmentUploadCount)
            //   window.location.reload();

            if (filedataAttachments.length == 1) {
              Materialize.toast(attchmentUploadCount + ' ATTACHMENT WAS UPLOADED', 2000);

              this.createicon = '';
              // (<HTMLInputElement>document.getElementById('uploadAttachmentButton')).disabled = false;
              this.uploadfilebtnstatus = false;
              progressCount = 0;
              // this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
              if (refreshAfterComplete) {
                this._service.removeAllFilesFromAttachmentArray();
                this.progresses.pop();
                this.ProjectCompleteAction.emit();
              }
            } else if (attchmentUploadCount == progressCount) {
              Materialize.toast(attchmentUploadCount + ' ATTACHMENTS WERE UPLOADED.', 2000);
              this.progresses = [];
              this._service.removeAllFilesFromAttachmentArray();
              this.createicon = '';
              // (<HTMLInputElement>document.getElementById('uploadAttachmentButton')).disabled = false;
              this.uploadfilebtnstatus = false;
              progressCount = 0;
              // this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
              if (refreshAfterComplete) {
                this._service.removeAllFilesFromAttachmentArray();
                this.progresses.pop();
                this.ProjectCompleteAction.emit();
              }
            }
          });
          progressCount++;
        }

        this.uploadService.progress$.subscribe(
          data => {
            console.log('upload progress = ' + data);
            let values = data.split('~');
            this.progresses[values[1]].currentValue = values[0];
            document.getElementById('progress' + values[1]).style.width = Number(values[0]) + '%';
          }
        );
      },
      error => {
        this.errorMessage = <any>error;
        Materialize.toast('UPLOAD FAILED - PLEASE TRY AGAIN', 2000);
        console.error('getProjectS3Creds() error:', this.errorMessage);
      }
    );
  }

 upload() {

  this.createicon = 'fa right fa-spinner fa-pulse';

    console.log('File attachment : ', this._service.getFileArrayofAttchments());
    let filedataAttachments = this._service.getFileArrayofAttchments().slice();

    // get the attached model (if creating project from scratch)
    let filedata = this._service.getFileAttached();
    this.filesToUpload = [filedata];
    console.log('files', this.filesToUpload);

    let projectdetails = {};
    let duplicationParams = {};

    // let modeltype_id = this.utilsService.determineModelType(projectdata.projects[key].filename);
    let modeltype_id = -1;

    // Create a project from an existing model file (My Workspace page)
    if (this.modelSelectedForProject) {
      projectdetails = {
        projectname: this.projectname,
        partnumber: this.partnumber,
        revision: this.revision,
        description: this.projectdescription,
        materialId: this.materialselect,
        assignee: this.selectedowner,
        customername: this.selectedcustomer,
        customerId: this.customerselect,
        assignedId: this.ownerselect,
        planid: this.planid
      };

      duplicationParams = {
        filename: this.ModelToProject.filename,
        name: this.projectname,
        number: this.partnumber
      };
      this.projectfilename = this.ModelToProject.filename;
    } else { // Uploading a model (Projects page)
      modeltype_id = this.utilsService.determineModelType(this.filesToUpload[0].name);
      console.log('Detected filetype:', modeltype_id);

      projectdetails = {
        project: {
          name: this.projectname,
          number: this.partnumber,
          revision: this.revision,
          description: this.projectdescription,
          material_id: this.materialselect,
          assigned_id: this.ownerselect,
          customer_id: this.customerselect,
          type: 2,
          modeltype_id: modeltype_id,
          file_size: this.filesToUpload[0].size,
          filename: this.filesToUpload[0].name
        }
      };

      duplicationParams = {
        filename: this.filesToUpload[0].name,
        name: this.projectname,
        number: this.partnumber
      };
      this.projectfilename = this.filesToUpload[0].name;
      console.log(duplicationParams);
    }

    this.createProjectService.checkDuplications(duplicationParams).subscribe(
      data => {

        console.log('Duplication data = ', data);
        let DupCheckData = JSON.parse(data);
        this.checkDuplications = false;
        this.dupnames = DupCheckData.dupnames;
        this.dupfilenames = DupCheckData.dupfilenames;
        this.dupnumbers = DupCheckData.dupnumbers;
        if (this.dupnames.length > 0) {
          this.duplicateName = true;
          for (let key in this.dupnames) {
            let filenamenoext = this.dupnames[key].filename.replace(/\.[^/.]+$/, '');      // Need to get file name from response
            if (!filenamenoext) {
              filenamenoext = ' ';
            }
            filenamenoext = filenamenoext.replace(/[+]/g, '%2B');
            this.dupnames[key].filenamenoext = filenamenoext;
            this.dupnames[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.dupnames[key].id + '/' + filenamenoext + '_320x240.png';
          }
        }
        if (this.dupfilenames.length > 0) {
          this.duplicateFilename = true;
          for (let key in this.dupfilenames) {
            let filenamenoext = this.dupfilenames[key].filename.replace(/\.[^/.]+$/, '');    // Need to get file name from response
            if (!filenamenoext) {
              filenamenoext = ' ';
            }
            filenamenoext = filenamenoext.replace(/[+]/g, '%2B');
            this.dupfilenames[key].filenamenoext = filenamenoext;
            this.dupfilenames[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.dupfilenames[key].id + '/' + filenamenoext + '_320x240.png';
          }
        }
        if (this.dupnumbers.length > 0) {
          this.duplicateNumber = true;
          for (let key in this.dupnumbers) {
            let filenamenoext = this.dupnumbers[key].filename.replace(/\.[^/.]+$/, '');  // Need to get file name from response
            if (!filenamenoext) {
              filenamenoext = ' ';
            }
            filenamenoext = filenamenoext.replace(/[+]/g, '%2B');
            this.dupnumbers[key].filenamenoext = filenamenoext;
            this.dupnumbers[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.dupnumbers[key].id + '/' + filenamenoext + '_320x240.png';
          }
        }

        if (this.dupfilenames.length > 0 || this.dupnames.length > 0 || this.dupnumbers.length > 0) {
          if (!this.confirmed) {
            this.createicon = '';
            this.modalcreateProjectConfirmAction.emit({ action: 'modal', params: ['open'] });
            return;
          } else {
            this.confirmed = false;
            this.createicon = 'fa right fa-spinner fa-pulse';
          }
        }
        let DupResult = [];

        // Upgrade existing model to project
        if (this.modelSelectedForProject) {
          this.createProjectService.convertModelToProject(this.ModelToProject, projectdetails)
          .subscribe(
            data => {
              console.log('startProcessing data:', data);
              console.log('actual startProcessing data:', this.ModelToProject);
              this.dupfilenames = [];
              this.dupnames = [];
              this.dupnumbers = [];
              this.confirmed = false;
              // Start a timer to refresh the page when translation is complete

              this.createProjectService.startProcessingUpload(this.ModelToProject.id, this.tenantid, this.ModelToProject.filename, this.planid)
              .subscribe(
                data => {

                  // if they chose a template
                  if (this.recipeTemplate) {
                    this.addRecipe(this.ModelToProject.id);
                  }
                  if (filedataAttachments.length) {
                    // (<HTMLInputElement>document.getElementById('uploadAttachmentButton')).disabled = true;
                    this.uploadfilebtnstatus = true;
                    Materialize.toast('PROJECT CREATED SUCCESSFULLY and UPLOADING ATTACHMENTS...', 2000);
                    this.uploadAttachments(true);
                  } else {
                    Materialize.toast('PROJECT ' + this.projectname + ' CREATED SUCCESSFULLY', 2000);
                    this.createicon = '';
                    this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
                    this.ProjectCompleteAction.emit();
                  }
                },
                error => {
                  this.createicon = '';
                  this.errorMessage = <any>error;
                  console.error('startProcessingUpload error:', this.errorMessage);
                }
              );
            },
            error => {
              this.createicon = '';
              this.errorMessage = <any>error;
              console.error('convertModelToProject error:', this.errorMessage);
            }
          );
        } else { // Create new project with new model

          this.uploadingproject = true;
          this.progressbarActive = true;

          // Create the project to be able to get the project ID
          this.createProjectService.addProject(this.filesToUpload, projectdetails)
            .subscribe(
            data => {
              console.log('Project added to DB');
              console.log('addProject data:', data);
              let projectdata = JSON.parse(data);
              let projectid = projectdata.projectid;
              console.log('Project ID:', projectid);
              let policy = projectdata.s3creds.s3Policy;
              let signature = projectdata.s3creds.s3Signature;
              let serverdate = projectdata.s3creds.serverDate;
              console.log('policy:', policy);
              console.log('signature:', signature);
              console.log('serverdate:', serverdate);

              // Upload the file to the newly created project bucket/folder makeProjectUploadRequest
              this.uploadService.makeProjectUploadRequest(this.tenanturl, [], this.filesToUpload, this.tenantid, this.planid, false, projectid, policy, signature, serverdate).then((result) => {
                console.log('Uploaded file. Result:', result);

                if (modeltype_id > 0) {
                  // translate
                  this.createProjectService.startProcessingUpload(projectid, this.tenantid, this.filesToUpload[0].name, this.planid)
                    .subscribe(
                    data => {
                      console.log('startProcessingUpload completed');

                      // if they chose a template
                  if (this.recipeTemplate) {
                    this.addRecipe(projectid);
                  }

                      this.uploadingproject = false;
                      this.progressbarActive = false;
                      let attchmentUploadCount = 0;
                      let fileuploadedCount = 0;
                      let progressCount = 0;

                      for (let uploadfilecount = 0; uploadfilecount < filedataAttachments.length; uploadfilecount++) {
                        let filepath = filedataAttachments[uploadfilecount].fullPath;
                        console.log('File path : ', filepath);

                        let splitname = filedataAttachments[uploadfilecount].name.split('.');
                        if (!splitname[0]) {
                          continue;
                        }
                        if (!filedataAttachments[uploadfilecount].name.includes('.')) {
                          continue;
                        }
                        this.progresses.push({ id: progressCount, currentValue: 1, name: filedataAttachments[uploadfilecount].name });


                        this.uploadService.makeFileRequest(this.tenanturl, [filepath, uploadfilecount, progressCount], filedataAttachments, projectid, null, this.tenantid, this.planid, policy, signature, serverdate).then((result) => {
                          console.log('Uploaded file. Result:', result);

                          fileuploadedCount++;

                          if (filedataAttachments.length == 1) {
                            Materialize.toast(fileuploadedCount + ' file was uploaded.', 3000);
                            this.progresses.pop();
                            this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });

                            Materialize.toast('Project Created Successfully.', 4000);
                            this.clearDropzone();
                            this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
                            Materialize.toast('PROJECT UPLOADED AND REFRESHING LIST...', 1000);
                            this.ProjectCompleteAction.emit();

                            progressCount = 0;
                          } else if (fileuploadedCount == progressCount) {
                            Materialize.toast(fileuploadedCount + ' files were uploaded.', 3000);
                            this.progresses = [];
                            this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });


                            Materialize.toast('Project Created Successfully.', 4000);
                            this.clearDropzone();
                            this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
                            Materialize.toast('PROJECT UPLOADED AND REFRESHING LIST...', 1000);
                            this.ProjectCompleteAction.emit();

                            progressCount = 0;
                          }
                        });
                        progressCount++;

                      }


                      this.uploadService.progress$.subscribe(
                        data => {
                          console.log('upload progress = ' + data);
                          let values = data.split('~');
                          this.progresses[values[1]].currentValue = values[0];
                        });

                      if (filedataAttachments.length == 0) {
                        this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
                        Materialize.toast('PROJECT UPLOADED AND REFRESHING LIST...', 1000);
                        this.ProjectCompleteAction.emit();
                      }
                    },
                    error => {
                      this.errorMessage = <any>error;
                      console.error('startProcessing error:', this.errorMessage);
                    });
                } else {
                  // Just trigger the database to set the upload status to 2
                  let updateProjectdetails = {
                    upload_status: 2
                  };

                  // Create the project to be able to get the project ID
                  this.createProjectService.updateProject(projectid, updateProjectdetails)
                    .subscribe(
                    data => {
                      console.log('Project updated');
                      this.progressbarActive = false;
                      this.clearDropzone();
                      Materialize.toast('Project uploaded Successfully.', 4000);
                      this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
                      console.log('startProcessingUpload completed');
                      this.ProjectCompleteAction.emit();
                    },
                    error => {
                      this.errorMessage = <any>error;
                      this.progressbarActive = false;
                      this.clearDropzone();
                      Materialize.toast('Project uploaded Successfully.', 4000);
                      this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
                      console.error('startProcessing error:', this.errorMessage);
                      this.ProjectCompleteAction.emit();
                    });
                }

              });
              this.uploadService.progress$.subscribe(
                data => {
                  console.log('upload progress = ' + data);
                  this.uploadCurrentValue = data;
                });
            },
            error => {
              this.uploadingproject = false;
              this.errorMessage = <any>error;
              console.error('getProjects() error:', this.errorMessage);
            });

          this.uploadingproject = false;
        }
      },
      error => {
        this.createicon = '';
        this.errorMessage = <any>error;
        console.error('checkDuplicates error:', this.errorMessage);
      }
    );
  }

  cancelClearConvertModal() {
    this.createicon = '';
    this.createanywayicon = '';
    this.ModelToProject = [];
    this.duplicateName = false;
    this.duplicateFilename = false;
    this.duplicateNumber = false;
    this.dupnames = [];
    this.dupfilenames = [];
    this.dupnumbers = [];
    this.revision = null;
    this.uploadprojectTabOn = false;
    this.clearDropzoneAttachments();
    this._service.removeAllFilesFromAttachmentArray();
    this.modalModel2ProjectAction.emit({ action: 'modal', params: ['close'] });
  }

  getKeyByValue(dictionary, value) {
    for (let i in dictionary) {
      if (dictionary.hasOwnProperty(i)) {
        if (dictionary[i] === value) {
          return i;
        }
      }
    }
  }

  clickProjectAttachments() {
    this.showUploadButton = true;
  }

  unclickProjectAttachments() {
    this.showUploadButton = false;
  }

  openInViewer(id: string, name: string) {
    // Build the URL
    let hwfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + name + '.hwf';

    console.log('openInViewer() URL: ', hwfurl);
    localStorage.setItem('hwfurl', hwfurl);
    // this.router.navigate(['/viewer']);
    openNewBrowserWindow('/#/viewer', hwfurl);
  }

  showAlerts() {
    jQuery('ul.tabs').tabs();
    jQuery('ul.tabs').tabs('select_tab', 'projectAlerts');
    this.createanywayicon = '';
    this.createanyway2icon = '';
  }

  showDuplicates() {
    this.createicon = '';
    this.showAlerts();
  }

  checkEmptyField(field) {
    if (field == 'name') {
      this.duplicateName = false;
    } else if (field == 'number') {
      this.duplicateNumber = false;
    }
    if (this.projectname && this.partnumber && this.revision && this.modelPresent) {
      this.createButtonStatus = true;
    } else {
      this.createButtonStatus = false;
    }
  }

  onMaterialChange(value) {
    console.log('material value', value);
    this.materialselect = value;
  }

  onCustomerChange(value) {
    console.log('customer value', value);
    this.customerselect = value;
  }

  onOwnerChange(value) {
    console.log('owner value', value);
    this.ownerselect = value;
  }

  onRecipeTemplateChange(value) {
    console.log('recipeTemplate value', value);
    this.recipeTemplate = value;
  }

  fileAddedToDropzone(event) {
    console.log(' file added to dropzone : ' + event);
    this.uploadfilebtnstatus = false;
  }

  fileRemovedFromDropzone(eventFile) {
    console.log(' File removed from Dropzone Attach');
    let fileURL;
    if (eventFile.fullPath) {
      fileURL = globals.TENANTURL + '/' + globals.BUCKETNAME + '/' + this.tenantid + '/' + this.ModelToProject.id + '/Attachments/' + eventFile.fullPath;
    } else {
      fileURL = globals.TENANTURL + '/' + globals.BUCKETNAME + '/' + this.tenantid + '/' + this.ModelToProject.id + '/Attachments/' + eventFile.name;
    } this.createProjectService.getFileStatus(fileURL).subscribe(
      data => {
        console.log(data.length);
        this.createProjectService.DeleteProjectAttachmentFile(fileURL).subscribe(
          data => {
            console.log('File deleted ');
          }
        );
      },
      error => {
        console.log('Error : ');
      }
    );
  }

  allfileRemoved() {
    this.uploadfilebtnstatus = true;
  }

  clearDropzoneAttachments() {
    this._dropzoneattach.clearDropzoneAttach();
  }

  ConfirmAnyway() {
    this.confirmed = true;
    this.createicon = '';
    this.createanywayicon = 'fa right fa-spinner fa-pulse';
    this.upload();
  }

  updateNewProjectInputs(event) {
    this.projectname = event.projectname;
    this.partnumber = event.partnumber;
    if (event.revision === null) {
      this.revision = event.revision;
    }
    this.modelPresent = true;

    let duplicationParams = {
      filename: event.filename
    };
    this.createProjectService.checkDuplications(duplicationParams)
    .subscribe(
      data => {
        jQuery('#projectDetailstab').click();
        console.log('Duplication data = ', data);
        let DupCheckData = JSON.parse(data);
        this.checkDuplications = false;
        this.dupfilenames = DupCheckData.dupfilenames;
        if (this.dupfilenames.length > 0) {
          this.duplicateFilename = true;
          for (let key in this.dupfilenames) {
            let filenamenoext = this.dupfilenames[key].filename.replace(/\.[^/.]+$/, '');    // Need to get file name from response
            if (!filenamenoext) {
              filenamenoext = ' ';
            }
            filenamenoext = filenamenoext.replace(/[+]/g, '%2B');
            this.dupfilenames[key].filenamenoext = filenamenoext;
            this.dupfilenames[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.dupfilenames[key].id + '/' + filenamenoext + '_320x240.png';
          }
        }

        let DupResult = [];

      },
      error => {
      }
    );
  }

  dropzoneEmpty(event) {
    this.modelPresent = false;
    this.duplicateFilename = false;
    this.duplicateNumber = false;
    this.duplicateName = false;
  }

  clearDropzone() {
    this._dropzone.clearMe();
    this._dropzoneattach.clearDropzoneAttach();

    this.projectname = null;
    this.partnumber = null;
    this.revision = null;
    this.projectdescription = null;

    this.ownerselect = 0;
    this.materialselect = 0;
    this.customerselect = 0;

  }

  addRecipe(projectid) {

    let templatename = '';
    this.recipeTemplates.forEach(element => {
      if (element.id == Number(this.recipeTemplate)) {
        templatename = element.name;
      }
    });

    let newrecipe = {
      type_id: 1, // estimate
      name: this.projectname + ' Recipe',
      template_id: Number(this.recipeTemplate),
      template_name: templatename,
      project_id: projectid
    };


    this.createProjectService.addRecipe(newrecipe).subscribe(
      data => {
          if (Number(data)) {

            Materialize.toast('RECIPE ' + newrecipe.name + ' CREATED SUCCESSFULLY', 1500);
            console.log('RECIPE ' + newrecipe.name + ' CREATED SUCCESSFULLY');
          }
      },
      error => {

      }
    );
  }

 // I had to replicate this here becasue the modal was appearing behind the create project modal when I referenced the code in the createcustomer files.
  // If you change any of this code, please replicate the changes in the Create Customer code at createcustomer.component.ts

  onCreateCustomerComplete() {
    this.service.getCorporateInfo().subscribe(
      data => {
        let jdata = JSON.parse(data);
        this.customerArray = jdata.customers;

        if (this.customerArray) {
            for (let i = 0; i < this.customerArray.length; i++) {
              this.customerDict[this.customerArray[i].id] = this.customerArray[i].name;
            }
          }

        // Could do something like this if we wanted to let them choose to not add a template after they start to select one (same for other fields too)
        // this.recipeTemplates.unshift({name: 'None', id: -1});
      },
      error => {

      }
    );
  }


  ////////////////////////////////
  // Create Customer stuff (putting this here because if we reference the other files it puts the modal behind this one)
  openModalNewAccount(ownerArray: any) {
    this.ownerArray = ownerArray;
    this.modalNewAccountAction.emit({ action: 'modal', params: ['open'] });
  }

createCustomer() {
    console.log(' Customer name : ' + this.companyname + ' first contact : ' + this.primarycontactfirstname + ' Second Contact : ' + this.primarycontactlastname);
    if (this.CustrequiredfieldEmpty) {
    Materialize.toast('Company Name, Priamary Contact name & Account owner fields are required!', 4000);
    return;
    }
    this.waiticon = 'fa right fa-spinner fa-pulse';
    (<HTMLInputElement>document.getElementById('CreateNewCustomer')).disabled = true;

    let rating = Number((<HTMLInputElement>document.getElementById('newcustomerrating')).value);
    this.planid = localStorage.getItem('mr_planid');

    let customerdetails = {
    companyname: this.companyname,
    addressone: this.addressone,
    addresstwo: this.addresstwo,
    companycity: this.companycity,
    companystate: this.companystate,
    companyzip: this.companyzip,
    companycountry: this.companycountry,
    companyphone: this.companyphone,
    companyfax: this.companyfax,
    companyurl: this.companyurl,
    primarycontactfirstname: this.primarycontactfirstname,
    primarycontactlastname: this.primarycontactlastname,
    primarycontactemail: this.primarycontactemail,
    primarycontactphone: this.primarycontactphone,
    accountowner: this.accountowner,
    owner_id: this.ownerselect,
    rating: rating,
    planid: this.planid
    };

    this.addCustomer(customerdetails)
    .subscribe(
    data => {
        console.log('customer data : ', data);
        this.waiticon = '';
        (<HTMLInputElement>document.getElementById('CreateNewCustomer')).disabled = false;
        Materialize.toast('NEW CUSTOMER CREATED SUCCESSFULLY', 2000);
        this.modalNewAccountAction.emit({ action: 'modal', params: ['close'] });
        this.onCreateCustomerComplete();
    },
    error => {
        this.waiticon = '';
        this.modalNewAccountAction.emit({ action: 'modal', params: ['close'] });
        (<HTMLInputElement>document.getElementById('CreateNewCustomer')).disabled = false;
    }
    );
}

addCustomer(customerdetails: any): Observable<string> {
    console.log('get users service called');

     let body;
    if (customerdetails.planid == 1) {
      body = JSON.stringify({ customer: { name: customerdetails.name } });
    } else {
      body = JSON.stringify({ customer: {
          name: customerdetails.companyname,
          address: customerdetails.addressone,
          address2: customerdetails.addresstwo,
          city: customerdetails.companycity,
          state: customerdetails.companystate,
          zip: customerdetails.companyzip,
          country: customerdetails.companycountry,
          phone: customerdetails.companyphone,
          fax: customerdetails.companyfax,
          email: customerdetails.primarycontactemail,
          website: customerdetails.companyurl,
          comments: customerdetails.comments,
          rating: customerdetails.rating,
          owner_id: customerdetails.owner_id,
        },
        primarycontact: {
            firstname: customerdetails.primarycontactfirstname,
            lastname: customerdetails.primarycontactlastname,
            phone: customerdetails.primarycontactphone,
            email: customerdetails.primarycontactemail,
            title: customerdetails.title
        }
      });
    }

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.customerurl);
    return this.authHttp.post(this.customerurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
}

private extractData(res: Response) {
let body = res.json();
console.log('BODY:', body);
return body || {};
}

handleError(error: any) {
// In a real world app, we might use a remote logging infrastructure
// We'd also dig deeper into the error to get a better message
let errMsg = (error.message) ? error.message :
    error.status ? `${error.status} - ${error.statusText}` : 'Server error';
console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
return Observable.throw(errMsg);
}
checkCustEmptyField() {
  if (this.companyname && this.primarycontactfirstname && this.primarycontactlastname) {
    this.CustrequiredfieldEmpty = false;
  } else {
    this.CustrequiredfieldEmpty = true;
  }
}

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/createproject/createproject.component.ts